import { render, staticRenderFns } from "./DashText.vue?vue&type=template&id=2ab6224e&scoped=true"
import script from "./DashText.vue?vue&type=script&lang=js"
export * from "./DashText.vue?vue&type=script&lang=js"
import style0 from "./DashText.vue?vue&type=style&index=0&id=2ab6224e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab6224e",
  null
  
)

export default component.exports